import React from 'react';
import CarnetsDeNotesRoot from 'containers/CarnetsDeNotes/Loadable';
import CarnetRoot from 'containers/CarnetsDeNotes/CarnetRootLoadable';
import { PageTrackerWrapper } from 'queries/user/track';
import CarnetEleveWrapper from 'containers/CarnetsDeNotes/CarnetEleve/Loadable';
import CarnetEleveEvaluations from 'containers/CarnetsDeNotes/CarnetEleve/Evaluations/Loadable';
import CarnetEleveMatieres from 'containers/CarnetsDeNotes/CarnetEleve/Matieres/Loadable';
import EvaluationsRoot from 'containers/CarnetsDeNotes/Evaluations/Loadable';
import { EvaluationForm } from 'containers/CarnetsDeNotes/Evaluations/EvaluationForm';
import { RedirectToAnotherEvaluation } from 'containers/CarnetsDeNotes/Evaluations/RedirectToAnotherEvaluation';
import CarnetDetails from 'containers/CarnetsDeNotes/CarnetDetails/Loadable';
import CarnetsDeNotesList from 'containers/CarnetsDeNotes/List/Loadable';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import PreviewCarnetElevePDF from './CarnetEleve/Preview/Loadable';
import { useParams } from 'react-router-dom';
import { carnetUrls } from 'containers/CarnetsDeNotes/urls';
import SchoolyearRedirect from 'components/Redirect/SchoolyearRedirect';
import { CarnetsDeNotesPreview } from 'containers/CarnetsDeNotes/Preview';

function RedirectToEvaluations() {
  const { carnetDeNotesId, eleveId } = useParams<{
    carnetDeNotesId: string;
    eleveId: string;
  }>();
  return (
    <SchoolyearRedirect
      to={carnetUrls.carnetEleve(carnetDeNotesId!, eleveId!)}
    />
  );
}

export const CarnetsDeNotesRoutes = {
  path: 'carnets-de-notes',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.carnetLivret.carnetsDeNotes" />
      <CarnetsDeNotesRoot />
    </>
  ),
  children: [
    {
      path: ':carnetDeNotesId',
      element: <CarnetRoot />,
      children: [
        {
          path: 'eleves/:eleveId',
          element: <CarnetEleveWrapper />,
          children: [
            {
              path: 'evaluations',
              children: [
                {
                  path: 'preview-pdf',
                  element: (
                    <PageTrackerWrapper title="CDN - évaluations - pdf">
                      <PreviewCarnetElevePDF groupBy="evaluation" />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  index: true,
                  element: (
                    <PageTrackerWrapper title="CDN - carnet élève - évaluations">
                      <CarnetEleveEvaluations />
                    </PageTrackerWrapper>
                  ),
                },
              ],
            },
            {
              path: 'matieres',
              children: [
                {
                  path: 'preview-pdf',
                  element: (
                    <PageTrackerWrapper title="CDN - évaluations - pdf">
                      <PreviewCarnetElevePDF groupBy="matiere" />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  index: true,
                  element: (
                    <PageTrackerWrapper title="CDN - carnet élève - matieres">
                      <CarnetEleveMatieres />
                    </PageTrackerWrapper>
                  ),
                },
              ],
            },
            {
              index: true,
              element: <RedirectToEvaluations />,
            },
          ],
        },
        {
          path: 'evaluations',
          element: <EvaluationsRoot />,
          children: [
            {
              path: ':evaluationId',
              element: (
                <PageTrackerWrapper title="CDN - évaluation">
                  <EvaluationForm />
                </PageTrackerWrapper>
              ),
            },
            {
              index: true,
              element: <RedirectToAnotherEvaluation />,
            },
          ],
        },
        {
          path: 'preview',
          element: <CarnetsDeNotesPreview />,
        },
        {
          index: true,
          element: <CarnetDetails />,
        },
      ],
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="CDN - liste">
          <CarnetsDeNotesList />
        </PageTrackerWrapper>
      ),
    },
  ],
};
